import { MechanicLoyaltyRptConstants } from '../constants';

export function MechanicLoyaltyRpt(state = {}, action) {
    switch (action.type) {
        case MechanicLoyaltyRptConstants.LOADING_REQUEST:
            return {
                ...state,
                loading: action.isbool
            };
        case MechanicLoyaltyRptConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case MechanicLoyaltyRptConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case MechanicLoyaltyRptConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case MechanicLoyaltyRptConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true
            };
        case MechanicLoyaltyRptConstants.GETEXPORT_SUCCESS:
            return {
                ...state,
                exportitems: action.datas
            };
        case MechanicLoyaltyRptConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state
    }

}